import { GridCellProps, GridColumn as Column } from '@progress/kendo-react-grid'
import { DashboardMenuOption } from 'components/dashboard-menu/constants'
import { HeaderComponent } from 'components/header/component'
import { SearchIcon } from 'components/icons/searchicon'
import { RasaContext } from 'context'
import { BaseClientEntity } from 'generic/baseClientEntity'
import { Dataset } from 'generic/dataset'
import * as GenericRedux from 'generic/genericRedux'
import { PagingSource, RasaDataGrid } from 'generic/rasaDataGrid'
import { RasaReactComponent } from 'generic/rasaReactComponent'
import * as React from 'react'
import { Button, Row } from 'reactstrap'
import { SharedKeys, SharedStore } from 'shared/data-layer/sharedStore'
import { DateTimeCell } from '../kendocells'
import { ToggleAssignmentCell } from './kendocells'
import './styles.scss'
import { isTruthy } from 'generic/utility'

interface EditSectionState {
  editName: boolean,
  name: string,
  search: string,
  sectionId: number,
  existingSections: any[],
  isSaveButtonDisabled: boolean,
  isDisplayErrorMsg: boolean,
  minArticleCount: number,
  isFullySectionedNewsletter: boolean,
}
class EditSectionComponent extends RasaReactComponent<any, EditSectionState> {
  public static contextType = RasaContext;
  private communityId: string = null
  private sharedStore: SharedStore
  constructor(p: any) {
    super(p, 'section')
    this.state = {
      editName: false,
      isDirty: false,
      isLoading: false,
      isSaving: false,
      name: '',
      search: '',
      sectionId: null,
      existingSections: [],
      isSaveButtonDisabled: true,
      isDisplayErrorMsg: false,
      minArticleCount: 0,
      isFullySectionedNewsletter: false,
    }
    this.intoEditMode = this.intoEditMode.bind(this)
  }

  public componentDidMount() {
    this.sharedStore = SharedStore.instance(this.context)
    Promise.all([
      this.sharedStore.getValue(SharedKeys.activeCommunity),
    ]).then(([activeCommunity]) => {
      this.communityId = activeCommunity.communityId
      this.loadSections()
      this.loadCommunityConfiguration()
    })
    const firstId = this.context.store.getState().app.params.id
    this.setState({sectionId: Number(firstId)})
    this.loadOnRouting(firstId, `${DashboardMenuOption.content}/editsection`)
  }

  public render = () => {
    return <div className="edit-section">
    <Row>

    </Row>
    <div className="header-container">
      <HeaderComponent
        title={'SECTIONS'}
        subTitle={'Edit Section'}
      />
    </div>
    <Row>
      <div className="section-box">
        <div className="text">
          <strong>Section</strong>
          <span className="rename" onClick={this.intoEditMode}>Edit</span>
        </div>
        <div className="text grey">
          {this.props.data.name}
        </div>
        {this.state.editName && (
          <div className="section-edit-container">
            {this.state.isFullySectionedNewsletter && (
              <div className="field-container">
                <div className="field-label">Minimum Article Count</div>
                <input className="field-textbox"
                      type="number"
                      min={0}
                      value={this.state.minArticleCount}
                      onChange={(e) => this.minArticleCountOnChange(e.target.valueAsNumber)} />
              </div>
            )}
            <div className="button-container">
              <Button className="save"
                      onClick={this.saveSection}
                      disabled={this.state.isLoading}
                      >Save</Button>
              <Button className="cancel"
                      onClick={() => this.setState({editName: false})}>Cancel</Button>
            </div>
          </div>
        )}
      </div>
    </Row>
    <Row>
      <div className="filters-section">
        <h5>Sources for this Section</h5>
        <p>Active or deactivate sources for this section</p>
      </div>
    </Row>
    <Row>
      <div className="search-bar">
          <label>
            <SearchIcon/>
            <input type="text"
                  value={this.state.search}
                  placeholder="Search..."
                  onChange={(e) => this.setSearch(e.target.value)}/>
          </label>
      </div>
        <RasaDataGrid
            entityName="communitySource"
            datasetName="subscriptionsBySection"
            datasetParams={[
              { param: 'section_idVal', value: this.state.sectionId },
            ]}
            editDefaultState={false}
            gridFilter={this.filterData}
            pagingSource={PagingSource.local}
            pageable={true}
            pageSize={25}
            resizable={true}
            sortable={true}
            data={[]}>
          <Column field="is_section_assigned" title="Assigned?" cell={this.SectionAssignmentToggleCell} />
          <Column field="source_type" title="Source" editable={false}/>
          <Column field="name" title="Name" editable={false}/>
          <Column field="last_week_total" title="# Upcoming" editable={false} width="95%"/>
          <Column field="created" title="Created" editable={false} cell={DateTimeCell}/>
        </RasaDataGrid>
      </Row>
    </div>
  }
  protected filterData = (s: any): boolean => {
    return this.state.search.length <= 3 || (
      (s.name && s.name.indexOf(this.state.search) >= 0) ||
      (s.source_type && s.source_type.indexOf(this.state.search) >= 0) ||
      (s.source_url && s.source_url.indexOf(this.state.search) >= 0)
    )
  }
  protected setSearch = (s: string) => {
    this.setState({
      search: s,
    })
  }
  
  private minArticleCountOnChange = (minArticleCount: number) => {
    this.setState({ minArticleCount })
  }
  private intoEditMode = () => {
    const minArticleCount = this.props.data.options ? JSON.parse(this.props.data.options).min_article_count : 0
    this.minArticleCountOnChange(minArticleCount)
    this.setState({editName: true, minArticleCount})
  }
  private toggleSectionAssignment = (id: number, isAssign: boolean) => {
    return this.context.entityMetadata
    .getEntityObject('subscriptionSection')
    .then((subscriptionSectionEntityObject: BaseClientEntity) => {
      subscriptionSectionEntityObject.setRecordId(this.communityId, null)
      subscriptionSectionEntityObject.data.section_id = this.state.sectionId
      subscriptionSectionEntityObject.data.subscription_id = id
      subscriptionSectionEntityObject.data.is_active = isAssign
      return subscriptionSectionEntityObject.save()
    })
  }

  private SectionAssignmentToggleCell = (props: GridCellProps) => {
    return <ToggleAssignmentCell {...props} onToggle={this.toggleSectionAssignment}/>
  }
  private loadSections = () => {
    return new Dataset().loadCommunityDataset('sections', this.communityId)
      .then((response) => {
        const sections = response[0] || []
        const mappedSections = sections.map(section => {
          let minArticleCount = 0
          if (section.options) {
            const options = JSON.parse(section.options)
            minArticleCount = options.min_article_count || 0
          }
          return {
            ...section,
            min_article_count: minArticleCount
          }
        })
        this.setState({ existingSections: mappedSections })
      })
  }
  private saveSection = () => {
    const existingOptions = this.props.data.options ? JSON.parse(this.props.data.options) : {}
    const newOptions = {
      ...existingOptions,
      min_article_count: this.state.minArticleCount
    }
    this.propertyChanged('options', JSON.stringify(newOptions))
    this.setState({
      isLoading: true,
    }, () => {
      this.saveRecord(this.props.data.id)
        .then(() => this.setState({ isLoading: false }))
        .then(() => {
          this.setState({editName: false})
        })
        .catch((error) => {
          // eslint-disable-next-line no-console
          console.log(`Error while saving, Error = ${error}`)
          this.setState({ isLoading: false })
        })
    })
  }
  private loadCommunityConfiguration = () => {
    const params = [
      {param: 'key', value: 'fully_sectioned_newsletter'},
    ]
    return new Dataset().loadCommunityDataset('communityConfiguration', this.communityId, params)
      .then((configuration) => {
        if (configuration.length > 0) {
          this.setState({
            isFullySectionedNewsletter: isTruthy(configuration[0][0].value)
          })
        }
      })
  }
}
export const ContentPoolEditSection = GenericRedux.registerNewNestedComponent(
  EditSectionComponent, 'edit_Section')
